import type { Guide, GuideRecordHint } from '../types';

/**
 * S-21.10-13 — zmianę zlecenia akceptuje właściciel pola (scenariusz e2e 20, krok 20.5 i scenariusz 16 — ADM-04;
 * ścieżki MIX-02, ADM-04). Rekordy: DEMO/2026/10/A02 z dwiema zgłoszonymi zmianami, które czekają na właściciela
 * pola — okno załadunku (CS) i waga (Administracja), zgłoszone w `scenario-state.mjs` (dane pod slajdy
 * z 22.10.2026) — i DEMO/2026/10/A01 do zgłoszenia nowej zmiany.
 */
const TMS_ORDER: GuideRecordHint = {
  description: 'dowolne zlecenie z TMS',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide' },
};

const PENDING: GuideRecordHint = {
  description: 'zlecenie ze zgłoszoną zmianą, która czeka na decyzję — z listy „Zmiany zleceń”',
  listPath: '/order-changes',
  listFilter: { status: 'pending' },
};

export const guide: Guide = {
  flagKey: 'orderChangeFieldOwner',
  title: 'Zmianę zlecenia akceptuje właściciel pola',
  whatItDoes:
    'Zmianę zgłoszoną w „Zmianach zlecenia” akceptuje właściciel zmienianego pola: termin (okna załadunku i rozładunku) i miejsce punktu — CS, waga, LDM i stawka — Administracja, uwagi — CS (miejsce, stawka i uwagi to wartości robocze, do potwierdzenia). Jedna zgoda właściciela zamyka decyzję: przy zmianie widać „akceptuje: …”, a przycisk „Akceptuj” ma tylko właściciel. Osoba realizująca (planowanie FTL albo Trade) dostaje powiadomienie o zgłoszeniu i może dodać uwagę, ale nie decyduje. Dotąd decydowali CS i osoba realizująca albo opiekun działu.',
  audience: ['CS', 'Administracja', 'planista FTL', 'Trade'],
  presentationItems: ['S-21.10-13'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: PENDING,
      target: 'order-changes-section',
      mockupTestId: 'cs-zmiana-akceptuj',
      title: 'Kto akceptuje zmianę',
      description:
        'Przy każdej zgłoszonej zmianie stoi „akceptuje: właściciel pola — CS” albo „— Administracja”, przy wartości roboczej z dopiskiem. Tu dwie zmiany czekają na decyzję: termin załadunku (CS — przy nim „Akceptuj”) i waga (Administracja — CS jej nie akceptuje). Po zgodzie właściciela zmianę wpisuje się w TMS jak dotąd.',
      action: 'Na karcie zlecenia znajdź sekcję „Zmiany zlecenia (było → ma być)” i przy zmianie, której jesteś właścicielem, kliknij „Akceptuj”.',
      recorder: { account: 'cs', demo: { kind: 'order', number: 'DEMO/2026/10/A02' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: TMS_ORDER,
      target: 'order-change-report-save',
      title: 'Zmiana terminu — decyduje CS',
      description:
        'Termin należy do CS, więc po zgłoszeniu CS sama akceptuje zmianę, bez Administracji i bez osoby realizującej. Zmianę wagi, LDM albo stawki akceptuje Administracja — na karcie zlecenia albo na liście „Zmiany zleceń”.',
      action: 'Kliknij „Zgłoś zmianę”, wybierz „Okno załadunku”, wpisz nowe okno i powód, zgłoś, a potem przy zmianie kliknij „Akceptuj”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'order', number: 'DEMO/2026/10/A01' },
        actions: [
          { kind: 'click', target: 'order-change-report' },
          { kind: 'select', label: 'Co się zmienia', option: 'Okno załadunku' },
          { kind: 'fill', target: 'order-change-reason', value: 'Klient przesuwa załadunek o dobę — telefon.' },
        ],
      },
    },
    {
      route: '/user-offers/:orderId/show',
      record: PENDING,
      target: 'order-change-consult',
      title: 'Osoba realizująca: powiadomienie i uwaga',
      description:
        'Dział, u którego jest zlecenie — planowanie FTL albo Trade — dostaje w dzwonku powiadomienie o zgłoszonej zmianie. Przy zmianie ma „Dodaj uwagę” zamiast „Akceptuj”: uwaga trafia do zmiany i do historii zlecenia, ale nie jest zgodą.',
      action: 'Otwórz powiadomienie albo kartę zlecenia i przy zmianie kliknij „Dodaj uwagę”.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/A02' } },
    },
  ],
};
